import React from 'react';
import { styled } from '@compiled/react';

import { N200, N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LabelDiv = styled.div({
	font: token('font.body'),
});

// (Note the the LabelDiv's color is automatically changed and passed down by the containing AkSelect control)

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DescriptionDiv = styled.div<{
	selected: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props) =>
		props.selected ? token('color.text.subtle', N300) : token('color.text.subtlest', N200),
	font: token('font.body.UNSAFE_small'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionDiv = styled.div({
	padding: `3px ${token('space.050', '4px')}`,
});

type OptionWithWithDescriptionProps = {
	label: string;
	description: string;
	isSelected: boolean;
};

export const OptionWithDescription = ({
	label,
	description,
	isSelected,
}: OptionWithWithDescriptionProps): JSX.Element => (
	<OptionDiv>
		<LabelDiv>{label}</LabelDiv>
		<DescriptionDiv selected={isSelected}>{description}</DescriptionDiv>
	</OptionDiv>
);
